import React from "react";
import "./Separador.css";

const Separador = () => {
  return <div className="separador"></div>;
};

export default Separador;
